
































import { Component, Prop, Vue } from "vue-property-decorator";
import SmallText from "@/common/components/atoms/SmallText.vue";

@Component({
  components: {
    SmallText
  }
})
export default class HSpecColumnList extends Vue {
  @Prop({ type: Number, required: true }) redemptionType!: number;
  @Prop({ type: Array || Boolean, required: true }) listItem!: any[] | boolean;
  @Prop({ type: String, default: "" }) columnSize!: string;

  get columnSizeClassName() {
    const { columnSize } = this;

    const resultClassName =
      columnSize !== "" ? `p-h-column-list__item--${columnSize}` : "";

    return resultClassName;
  }

  giftCode(text: string) {
    if (this.redemptionType === 3) {
      return `<a href="${text}" target="_blank">${text}</a>`;
    }

    return text;
  }
}
